<template>
  <form @submit.prevent="submitForm()">
    <div class="page-wrap p-3">
      <div class="mt-3 mb-3">
        <a :href="`/intergov-expenses`">
          <span><i class="fa fa-chevron-left" aria-hidden="true"></i></span>
          Назад
        </a>
      </div>

      <div class="page-header p-3 mb-3 mt-3">
        <h3>Редактирование расходов по межправ</h3>
      </div>
    </div>
    <div class="page-content mt-3 mb-3">
      <div class="col-md-12">
        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="iin" class="form-label col-md-5">
              ВУЗ
            </label>
            <div class="col-md-7">
              <select v-model="dto.universityId"
                      :disabled="true"
                      class="form-select">
                <option v-for="university in universities" :key="university.universityId"
                        :value="university.universityId">
                  {{ university.nameRu }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="lastname" class="form-label col-md-5">
              Год
            </label>
            <div class="col-md-7">
              <select v-model="dto.trancheYear" id="trancheYear"
                      class="form-select">
                <option v-for="(year, index) in trancheYears" :key="year" :value="year">
                  {{ year }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12 " v-if="dto.detailsMap" style="padding-top: 3px">

        <table class="table table-bordered table-striped expenses-detail">
          <thead>
          <tr>
            <th></th>
            <th style="width: 150px;">Тип расходов</th>
            <th style="width: 250px">Смета расходов</th>
            <th>План {{dto.trancheYear}} г.</th>
            <th>Факт  за 1 кв {{dto.trancheYear}} г. </th>
            <th>Факт  за 2 кв {{dto.trancheYear}}  г. </th>
            <th>Факт  за 3 кв {{dto.trancheYear}}  г. </th>
            <th>Факт  за 4 кв {{dto.trancheYear}}  г. </th>
            <th style="width: 50px"></th>
          </tr>
          </thead>
          <tbody>
          <template v-for="(typeTitle, code) in type1" :key="code">
          <tr  v-if="dto.detailsMap[code]">

            <td rowspan="7" v-if="code ==='JOB_PAYMENT' ">1</td>
            <td rowspan="7"  v-if="code ==='JOB_PAYMENT' ">Выплата заработной платы работникам</td>
            <td>{{ typeTitle }}</td>
            <td class="expense-sum-edit">
                <span v-if="!dto.detailsMap[code].isEdit"> {{ dto.detailsMap[code].totalPlanSum }} </span>
               <input v-if="dto.detailsMap[code].isEdit" class="form-control" type="number"
                     v-model="tmpDetailsMap[code].totalPlanSum">
            </td>
            <td class="expense-sum-edit">
              <span v-if="!dto.detailsMap[code].isEdit"> {{ dto.detailsMap[code].sumTranche1 }}</span>
              <input v-if="dto.detailsMap[code].isEdit" class="form-control" type="number"
                     v-model="tmpDetailsMap[code].sumTranche1">
            </td>
            <td class="expense-sum-edit">
              <span v-if="!dto.detailsMap[code].isEdit"> {{ dto.detailsMap[code].sumTranche2 }} </span>
              <input v-if="dto.detailsMap[code].isEdit" class="form-control" type="number"
                     v-model="tmpDetailsMap[code].sumTranche2">
            </td>
            <td class="expense-sum-edit">
              <span v-if="!dto.detailsMap[code].isEdit">{{ dto.detailsMap[code].sumTranche3 }}  </span>
              <input v-if="dto.detailsMap[code].isEdit" class="form-control" type="number"
                     v-model="tmpDetailsMap[code].sumTranche3">
            </td>
            <td class="expense-sum-edit">
              <span v-if="!dto.detailsMap[code].isEdit">  {{ dto.detailsMap[code].sumTranche4 }} </span>
              <input v-if="dto.detailsMap[code].isEdit" class="form-control" type="number"
                     v-model="tmpDetailsMap[code].sumTranche4">
            </td>
            <td>
              <el-button type="text" class="btn-icon"
                         v-if="!dto.detailsMap[code].isEdit"
                         @click="onShowRowEdit(code)">
                <font-awesome-icon :icon="['fas', 'pencil']"/>
              </el-button>

              <el-button type="text" class="btn-icon color-green"
                         v-if="dto.detailsMap[code].isEdit" @click="onEditRowApprove(code)">
                <font-awesome-icon :icon="['fas', 'check']"/>
              </el-button>

              <el-button type="text" class="btn-icon color-red"
                         v-if="dto.detailsMap[code].isEdit"
                         @click="onEditRowCancel(code)">
                <font-awesome-icon :icon="['fas', 'cancel']"/>
              </el-button>
            </td>
          </tr>
          </template>
          <tr>
            <td><b>Всего расходы заработной платы работникам</b></td>
            <td>{{getTotalAmount(type1, 'totalPlanSum')}}</td>
            <td>{{getTotalAmount(type1, 'sumTranche1')}}</td>
            <td>{{getTotalAmount(type1, 'sumTranche2')}}</td>
            <td>{{getTotalAmount(type1, 'sumTranche3')}}</td>
            <td>{{getTotalAmount(type1, 'sumTranche4')}}</td>
            <td></td>
          </tr>

<!--     type 2      -->
          <template v-for="(typeTitle, code) in type2" :key="code">
          <tr v-if="dto.detailsMap[code]" :class="`${code}`">

            <td rowspan="14" v-if="code ==='PAYMENT_FOR_UTILITIES' ">2</td>
            <td rowspan="14"  v-if="code ==='PAYMENT_FOR_UTILITIES' ">расходы, связанные с эксплуатацией инженерных коммуникаций (электро-тепло-водоснабжение, канализация)</td>
            <td>{{ typeTitle }}</td>
            <td class="expense-sum-edit">
              <span v-if="!dto.detailsMap[code].isEdit"> {{ dto.detailsMap[code].totalPlanSum }} </span>
              <input v-if="dto.detailsMap[code].isEdit" class="form-control" type="number"
                     v-model="tmpDetailsMap[code].totalPlanSum">
            </td>
            <td class="expense-sum-edit">
              <span v-if="!dto.detailsMap[code].isEdit"> {{ dto.detailsMap[code].sumTranche1 }}</span>
              <input v-if="dto.detailsMap[code].isEdit" class="form-control" type="number"
                     v-model="tmpDetailsMap[code].sumTranche1">
            </td>
            <td class="expense-sum-edit">
              <span v-if="!dto.detailsMap[code].isEdit"> {{ dto.detailsMap[code].sumTranche2 }} </span>
              <input v-if="dto.detailsMap[code].isEdit" class="form-control" type="number"
                     v-model="tmpDetailsMap[code].sumTranche2">
            </td>
            <td class="expense-sum-edit">
              <span v-if="!dto.detailsMap[code].isEdit">{{ dto.detailsMap[code].sumTranche3 }}  </span>
              <input v-if="dto.detailsMap[code].isEdit" class="form-control" type="number"
                     v-model="tmpDetailsMap[code].sumTranche3">
            </td>
            <td class="expense-sum-edit">
              <span v-if="!dto.detailsMap[code].isEdit">  {{ dto.detailsMap[code].sumTranche4 }} </span>
              <input v-if="dto.detailsMap[code].isEdit" class="form-control" type="number"
                     v-model="tmpDetailsMap[code].sumTranche4">
            </td>
            <td>
              <el-button type="text" class="btn-icon"
                         v-if="!dto.detailsMap[code].isEdit"
                         @click="onShowRowEdit(code)">
                <font-awesome-icon :icon="['fas', 'pencil']"/>
              </el-button>

              <el-button type="text" class="btn-icon color-green"
                         v-if="dto.detailsMap[code].isEdit" @click="onEditRowApprove(code)">
                <font-awesome-icon :icon="['fas', 'check']"/>
              </el-button>

              <el-button type="text" class="btn-icon color-red"
                         v-if="dto.detailsMap[code].isEdit"
                         @click="onEditRowCancel(code)">
                <font-awesome-icon :icon="['fas', 'cancel']"/>
              </el-button>
            </td>
          </tr>
          </template>
          <tr>
            <td><b>Всего расходы, связанные с эксплуатацией инженерных коммуникаций (электро-тепло-водоснабжение, канализация)</b></td>
            <td>{{getTotalAmount(type2, 'totalPlanSum')}}</td>
            <td>{{getTotalAmount(type2, 'sumTranche1')}}</td>
            <td>{{getTotalAmount(type2, 'sumTranche2')}}</td>
            <td>{{getTotalAmount(type2, 'sumTranche3')}}</td>
            <td>{{getTotalAmount(type2, 'sumTranche4')}}</td>
            <td></td>
          </tr>

          <tr>
            <td></td>
            <td></td>
            <td><b>Общая сумма </b></td>
            <td>{{dto.totalPlanSum}}</td>
            <td>{{dto.sumTranche1}}</td>
            <td>{{dto.sumTranche2}}</td>
            <td>{{dto.sumTranche3}}</td>
            <td>{{dto.sumTranche4}}</td>
            <td></td>
          </tr>
          </tbody>

        </table>
        </div>

      <!-- Подтверждающий документ -->
      <div class="row col-md-9" v-for="(number, index) in trancheNumbers" >
        <div class="el-input-group" v-if="number <= setting.defaultTrancheNumber">
          <label class="form-label col-md-5">
            Подтверждающий документ за {{number}} кв(PDF)
          </label>
          <div class="col-md-7" v-if="dto['file' + number]">
            <a href="javascript:void(0)" @click="downloadFile(number)">
              {{ dto['file' + number].name }}
            </a>

            <b-button variant="danger"
                      class="btn-sm"
                      style="margin-left: 20px"
                      v-if="canRemoveFile(number)"
                      @click="onClickRemoveFile(number)">
              Удалить
            </b-button>
          </div>
          <div class="col-md-7" v-if="!dto['file' + number]">
            <input type="file"
                   :disabled="isDisabled()"
                   @change="handleFileUpload($event, number)" accept=".pdf" class="form-control"/>
          </div>
        </div>
      </div>
      </div>

    <div class="page-footer justify-content-end">
      <b-button variant="success" type="submit" v-if="hasEditPermission()">
        Сохранить
      </b-button>
    </div>
  </form>

  <vue-loading :active.sync="isLoading" :is-full-page="true"></vue-loading>
</template>

<script>

import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import {showErrorNotify, showSuccessNotify} from "@/utils/notificationUtils";
import delegationService from "@/services/delegationService";
import authService from "@/services/authService";
import intergovExpensesService from "@/services/intergovExpensesService";
import universityService from "@/services/universityService";
import fileService from "@/services/fileService";
import settingsService from "@/services/settingsService";

export default {
  components: {
    VueLoading
  },
  computed: {
    uuid() {
      return this.$route.params.uuid;
    }
  },
  data() {
    return {
      isLoading: false,
      dto: {
        uuid: null,
        trancheYear: null,
        universityId: null,
        totalSum: null,
        totalPlanSum: null,
        detailsMap: null
      },
      uploadedFile1: null,
      uploadedFile2: null,
      uploadedFile3: null,
      uploadedFile4: null,
      setting: {},
      tmpDetailsMap: {},
      universities: [],
      type1: {
        JOB_PAYMENT: "Оплата труда",
        SOCIAL_TAX: "Социальный налог",
        SOCIAL_PAYS: "Социальный отчисления",
        MED_INSURANCE: "Обязательное медицинское страхование",
        OPVR: "ОПВР",
        COMPENSATION_PAYMENT: "Компенсационные выплаты",
      },
      type2: {
        PAYMENT_FOR_UTILITIES: "Оплата коммунальных услуг(холодная вода,горячая вода,канализация,отопление)",
        PFU_NEW_BUILDING: "в.т.ч . Новый учебный корпус",
        PFU_OLD_BUILDING: "в т.ч. Старый учебный корпус",
        PFU_EDU_BUILDING: "в т.ч.Учебно-методический отдел",
        PFU_DORMITORY: "в т.ч.Общежитие",
        PAYMENT_FOR_ELECTR: "Оплата электроэнергии",
        PFE_NEW_BUILDING: "в.т.ч . Новый учебный корпус",
        PFE_OLD_BUILDING: "в т.ч. Старый учебный корпус",
        PFE_EDU_BUILDING: "в т.ч.Учебно-методический отдел",
        PFE_DORMITORY: "в т.ч.Общежитие",
        OTHER_PAYMENT: "Оплата прочих услуг и работ",
        OP_SECURITY_SERVICE: "охранные услуги",
        OP_TRASH: "вывоз ТБО"
      },
      trancheYears: Array.from({length: 7}, (v, i) => 2024 + i),
      trancheNumbers: [1, 2, 3, 4],
      managerRoles: authService.getManagerRoles(),
      universityManagerRoles: authService.getUniversityManagerRoles(),
    };
  },
  methods: {
    init() {
      const user = JSON.parse(localStorage.getItem("currentUserUniversityInfo") || "{}");

      this.findById(this.uuid);
      this.initUniversities();
      this.initSettings();
    },
    initUniversities() {
      const params = {
        partNumber: 1,
        countInPage: 0,
        filter: {}
      };
      universityService.getAll(params)
          .then(response => {
            this.universities = response.list.sort((a, b) => a.nameRu.localeCompare(b.nameRu));
          });
    },
    async initSettings() {
      this.setting = await settingsService.load();
    },
    onShowRowEdit(code) {
      this.dto.detailsMap[code].isEdit = true;
      this.tmpDetailsMap[code] = Object.assign({}, this.dto.detailsMap[code]);
    },
    
    onEditRowApprove(code) {
      this.dto.detailsMap[code] = Object.assign({}, this.tmpDetailsMap[code]);
      this.dto.detailsMap[code].isEdit = false;
      this.dto.totalPlanSum = this.getTotalAmount( this.dto.detailsMap, 'totalPlanSum');
      this.dto.sumTranche1 = this.getTotalAmount( this.dto.detailsMap, 'sumTranche1');
      this.dto.sumTranche2 = this.getTotalAmount( this.dto.detailsMap, 'sumTranche2');
      this.dto.sumTranche3 = this.getTotalAmount( this.dto.detailsMap, 'sumTranche3');
      this.dto.sumTranche4 = this.getTotalAmount( this.dto.detailsMap, 'sumTranche4');
    },
    
    onEditRowCancel(code) {
      this.dto.detailsMap[code].isEdit = false;
    },

    async findById(uuid) {
      this.isLoading = true;
      this.dto = await intergovExpensesService.findById4Edit(uuid); 
      this.isLoading = false;
    },
    async submitForm() {
      try {
        if (!this.hasEditPermission()) {
          return;
        }

        this.isLoading = true;


        for (let i = 1; i <= 4; i++) {

          if (!this.dto['file' + i] && this['uploadedFile' + i]) {
            const formData = new FormData();
            formData.append('intergovExpensesId', this.dto.uuid);
            formData.append('file', this['uploadedFile' + i]);
            this.dto['file' + i] = await fileService.uploadFile(formData);
          }
        }




        this.dto = await intergovExpensesService.save(this.dto);

        if (this.uuid === '-1') {
          this.$router.push({ name: 'IntergovExpensesEditView', params: { uuid: this.dto.uuid } });
        }

        showSuccessNotify("Успешно сохранено!");
      } catch (exc) {
        showErrorNotify("Возникла ошибка при сохранении");
      } finally {
        this.isLoading = false;
      }
    },
    handleFileUpload(event, index) {
      const file = event.target.files[0];
      if (file) {
        this['uploadedFile' + index] = file;
      } else {
        showErrorNotify("Выберите файл для загрузки");
      }
    },

    async downloadFile(index) {
      await fileService.download(this.dto['file'+index]['uuid'], this.dto['file'+index]['name']);
    },

    canRemoveFile(index) {
      if (this.hasEditPermission()) {
        const status = this.dto['status' + index];
        if (!status || status === 'CREATED') {
          return true;
        }
      }
      return false;
    },
    async onClickRemoveFile(index) {
      const confirmed = await confirm("Вы уверены, что хотите удалить данный файл?");
      if (confirmed) {
        try {
          await fileService.deleteFileById(this.dto['file' + index]['uuid']);
          this.dto['file' + index] = null;

          showSuccessNotify('Успешно удалено');
        } catch (exc) {
          showErrorNotify('Возникла ошибка при удалении');
        }
      }
    },

    getTotalAmount(types, column) {
      let totalAmount = 0;
      const keys = Object.keys(types);

      for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        if (this.dto.detailsMap[key]) {
          totalAmount += parseFloat(this.dto.detailsMap[key][column]) || 0;
        }
      }
      return totalAmount.toFixed(2);
    },
    isDisabled() {
      return this.hasEditPermission() === false;
    },
    hasEditPermission() {
      return this.isUniversityManager() && (this.dto.status === 'CREATED'  || !this.dto.status);
    },
    isAdmin() {
      return delegationService.isAdmin();
    },
    isUniversityManager() {
      return delegationService.isUniversityManager();
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style scoped>
.row {
  padding-top: 5px;
}
.PFU_NEW_BUILDING, .PFU_OLD_BUILDING, .PFU_EDU_BUILDING, .PFU_DORMITORY, .PFE_NEW_BUILDING, .PFE_OLD_BUILDING, .PFE_EDU_BUILDING, .PFE_DORMITORY, .OP_SECURITY_SERVICE, .OP_TRASH {
  font-style: italic;
}
table.expenses-detail tr td {
  padding: 0 !important;
  padding-left: 5px !important;
  font-size: 14px;
}
table.expenses-detail tr td.expense-sum-edit:has(.form-control){
  padding-left: 0 !important;
}

table.expenses-detail tr td.expense-sum-edit .form-control {
  padding-left: 2px !important;
  font-size: 14px !important;
}

.color-green, .color-green:hover {
  color: green !important;
}

.color-red, .color-red:hover {
  color: red !important;
}
</style>
